/**
 * Per-area remembered audio mode storage.
 *
 * Used by AudioEntry to skip the 3-button selector on repeat visits when
 * the user has opted in via "Remember my preference".
 */

const KEY = (area) => `reclaim_remembered_mode_${area || "default"}`;

export function getRemembered(area) {
  try {
    const raw = localStorage.getItem(KEY(area));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.remember || !parsed?.mode) return null;
    return parsed; // { mode, remember: true, savedAt }
  } catch {
    return null;
  }
}

export function saveRemembered(area, mode, remember) {
  try {
    if (remember && mode) {
      localStorage.setItem(
        KEY(area),
        JSON.stringify({ mode, remember: true, savedAt: Date.now() })
      );
    } else {
      localStorage.removeItem(KEY(area));
    }
  } catch {}
}

export function clearRemembered(area) {
  try {
    localStorage.removeItem(KEY(area));
  } catch {}
}
